import { BuiltCampaignControllerAction } from "./BuiltCampaignControllerAction";
export class BuiltCampaignControllerActionStepSignal extends BuiltCampaignControllerAction {
    constructor(response, context) {
        super(response, context);
        this.name = response.name;
    }
}
